// 編輯頁歌單上的流程小標（內部調整 / 導演審查中 / 待轉交）；點了開導演頁那首歌。
import { Link } from 'react-router-dom';
import type { Song } from '../lib/api';
import { gateStageTag } from '../lib/editorGate';
import { songPageHref } from '../lib/notifications';
import './GateStageTag.css';

export default function GateStageTag({ projectId, song }: { projectId: string; song: Pick<Song, 'id' | 'gate'> }) {
  const tag = gateStageTag(song);
  if (!tag) return null;
  return (
    <Link
      className={`gate-tag gate-tag--${tag.stage}`}
      to={songPageHref('preview', projectId, { songId: song.id })}
      title="到導演頁看這首歌"
      onClick={(e) => e.stopPropagation()}
    >
      {tag.label}
    </Link>
  );
}
